<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
     <!-- <div class="dlblock-mb20 mr10">
        <span class="pr5">创建时间</span>
        <el-date-picker
            v-model="date"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">状态</span>
        <el-select v-model="status" placeholder="全部" class="w150" clearable>
          <el-option v-for="(item, index) in statusList" :key="index" :label="item.name" :value="item.id"/>
        </el-select>
      </div> -->
      <div class="dlblock-mb20 mr10">
        <span class="pr5">标题</span>
        <el-input v-model.trim="title" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">作者名称</span>
        <el-input v-model.trim="authorName" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="pages.page = 1; getYDProductListPageFn()">
          搜索
        </el-button>
      </div>

    <!--  <div class="dlblock-mb20">
        <el-button type="primary" @click="getGrabFn()">
          抓取数据
        </el-button>
      </div> -->

    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="title" label="标题"></el-table-column>
      <el-table-column align="center" prop="authorName" label="作者名称"></el-table-column>

      <el-table-column align="center"  label="图片">
	    <template slot-scope="{row}">
	      <el-image class="m-box-img" :src="row.cover" @click="editBtn(3,row)" lazy></el-image>
	    </template>
	    </el-table-column>

      <el-table-column align="center" prop="publishedAt" label="时间"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="{row}">
          <!-- 1)查看  2)取消置顶 3)下架 4)消息推送 5)编辑 6)删除 7)置顶 8)重新发布 -->
          <a class="glob-a" @click="editBtb(row.id, 1)">
            查看
          </a>
          <a class="glob-a" v-if="row.status == '5' || row.status == '6'" @click="editBtb(row.informationId, 2)">
            取消置顶
          </a>
          <a class="glob-a" v-if="row.status == '2'" @click="editBtb(row.informationId, 7)">
            置顶
          </a>
          <a class="glob-a" v-if="row.status == '5' || row.status == '6' || row.status == '2'"
             @click="editBtb(row.informationId, 3)">
            下架
          </a>
          <a class="glob-a" v-if="row.status == '6' || row.status == '5'" @click="editBtb(row.informationId, 4)">
            消息推送
          </a>
          <a class="glob-a"  @click="editBtb(row.id, 5)">
            编辑
          </a>
          <!--          <a class="glob-a" v-if="row.status == '3' || row.status == '4'" @click="editBtb(row.informationId, 8)">-->
          <!--            重新发布-->
          <!--          </a>-->
          <a class="glob-a" @click="editBtb(row.id, 6)">
            删除
          </a>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <!-- 已通过详情 -->
    <el-dialog title="查看" :visible.sync="detailModal" fullscreen>
      <detail :data="detailData"/>
    </el-dialog>

    <!-- 置顶 -->
    <el-dialog title="置顶" :visible.sync="topData.modal">
      <el-form style="min-height: 200px;">
        <el-form-item label="置顶位置" label-width="100px">
          <el-radio-group v-model="topData.radio">
            <el-radio label="1">全国置顶1</el-radio>
            <el-radio label="2">全国置顶2</el-radio>
            <el-radio label="3">全国置顶3</el-radio>
            <el-radio label="4">全国置顶4</el-radio>
            <el-radio label="5">全国置顶5</el-radio>
          </el-radio-group>
          <div class="mt10">
            <el-radio v-model="topData.radio" label="6">区域置顶</el-radio>

            <el-cascader
                style="width: 500px;"
                ref="refTopCity"
                v-show="topData.radio == '6'"
                v-model="topData.city"
                :options="cityList"
                :props="{value: 'code', label: 'name', multiple: true}"
                clearable
            />
          </div>

        </el-form-item>
        <el-form-item label="置顶日期" label-width="100px">
          <el-date-picker
              v-model="topData.date"
              style="width: 300px;"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
          />
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="topData.modal = false">取 消</el-button>
        <el-button type="primary" @click="topSave">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑 -->
    <el-dialog title="编辑" :visible.sync="editData.modal" fullscreen>
      <edit :id="editData.id" @close="editModalClose" is-edit/>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getGrab,
    getYDProductListPage,
    getYDProductDetail,
    getDelYDProductOrDetail,

    getInformationAuditMsg,
    setInformationAuditSoldOut,
    setInformationAuditCancelTop,
    setInformationAuditTop,
    delInformationMine,
    getInformationCityTreeByUserRole
  } from '@/api'

  import Detail from '../components/Detail'
  import Edit from '../components/Edit'

  export default {
    name: 'InformationPlatform',
    components: {Detail, Edit},
    data () {
      return {
        date: [],
        classify: '',
        status: '',
        statusList: [
          {id: '1', name: '待审核'},
          {id: '2', name: '已发布'},
          {id: '3', name: '未通过'},
          {id: '4', name: '已下架'},
          {id: '5', name: '区域置顶'},
          {id: '6', name: '全国置顶'},
        ],
        title: '',
        authorName:'',
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        detailModal: false,
        detailData: {},
        topData: {
          modal: false,
          id: '',
          radio: '1',
          date: [],
          city: []
        },
        cityList: [],
        editData: {
          modal: false,
          id: ''
        }
      }
    },
    created () {
      this.getYDProductListPageFn()
      //this.getInformationCityTreeByUserRoleFn()
    },
    methods: {
      editModalClose (t) {
        this.editData.modal = false
        t && this.getYDProductListPageFn()
      },
      topSave () {
        let temp = {
          informationId: this.topData.id,
          startTime: this.topData.date && this.topData.date.length ? this.topData.date[0] : '',
          endTime: this.topData.date && this.topData.date.length > 1 ? this.topData.date[1] : '',
        }
        if (this.topData.radio == '6') {
          temp.stickType = 'AREA'
          temp.cityCodes = this.$refs['refTopCity'].getCheckedNodes(true).map(item => item.value)
        } else {
          temp.stickType = 'NATION'
          temp.nationIndex = this.topData.radio
        }
        setInformationAuditTop(temp).then(res => {
          this.$message.success(res.data)
          this.topData.modal = false
          this.getYDProductListPageFn()
        })
      },
      // 1)查看  2)取消置顶 3)下架 4)消息推送 5)编辑 6)删除 7)置顶 8)重新发布
      editBtb (id, t) {
        switch (t) {
          case 1:
            getYDProductDetail({id:id}).then(res => {
              this.detailModal = true
              this.detailData = res.data
            })
            break
          case 2:
            this.$confirm('确认取消置顶吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              setInformationAuditCancelTop(id).then(res => {
                this.$message.success(res.data)
                this.getYDProductListPageFn()
              })
            }).catch(() => {
            })
            break
          case 3:
            this.$confirm('确认下架吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              setInformationAuditSoldOut({
                informationId: id,
              }).then(res => {
                this.$message.success(res.data)
                this.getYDProductListPageFn()
              })
            }).catch(() => {
            })
            break
          case 4:
            break
          case 5:
		  console.info("编辑时间触发")
            this.editData = {
              modal: true,
              id
            }
            break
          case 6:
            this.$confirm('确认删除吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              getDelYDProductOrDetail({id:id}).then(res => {
                this.$message.success(res.msg)
                this.getYDProductListPageFn()
              })
            }).catch(() => {
            })
            break
          case 7:
            this.topData = {
              modal: true,
              radio: '1',
              id,
              date: [],
              city: []
            }
            break
          case 8:
            this.$router.push({name: 'InformationEdit', query: {id}})
            break
        }
      },
      getYDProductListPageFn () {
        this.tableLoading = true
        getYDProductListPage({
          tags: this.classify,
          title: this.title,
          authorName:this.authorName,
          status: this.status,
          pageNum: this.pages.page,
          startTime: this.date && this.date.length ? this.date[0] : '',
          endTime: this.date && this.date.length > 1 ? this.date[1] : '',
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getYDProductListPageFn()
      },
      getInformationCityTreeByUserRoleFn () {
        getInformationCityTreeByUserRole().then(res => {
          this.cityList = res.data
        })
      },
      //银达产品，产品详情抓取
      getGrabFn(){
         this.tableLoading = true
        getGrab({}).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      }
    }
  }
</script>

<style scoped>
</style>
